import { FlexColumn, FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import { EventDetail } from './EventDetail';
import { EventList } from './EventList';

export function Events() {
  const { theme, css } = useStyles();

  return (
    <FullContainer flexible>
      <FlexColumn
        classNames={css({
          width: `400px`,
          padding: theme.sizing.scale600,
          borderRight: `1px solid ${theme.colors.borderOpaque}`,
        })}
      >
        <EventList />
      </FlexColumn>
      <FullContainer
        flexible
        classNames={css({
          boxSizing: 'border-box',
          flexDirection: 'column',
          padding: theme.sizing.scale600,
        })}
      >
        <EventDetail />
      </FullContainer>
    </FullContainer>
  );
}
